import React, { FC, useState } from 'react'
import { message } from 'antd'
import Form, { FormComponentProps } from 'antd/lib/form/Form'
import { FormNames } from 'Constants/FormNames'
import { useAppDispatch, useUnmount } from 'Src/hooks'
import {
	interfaceElementSlice,
	interfaceElementsSelector,
	InterfaceElementModel,
} from 'Pages/interfaceElement'
import {
	BtnComponent,
	DrawerComponent,
	FormBlockComponent,
	i18n,
	InputComponent,
	SelectComponent,
} from 'LibNeo'
import { dictsSelector } from 'Modules'
import { useSelector } from 'react-redux'
import { FieldNames } from 'Constants/FieldNames'
import { Deserialize } from 'cerialize'
import { Block, WrapperButton } from './styled'

const actions = {
	createOne: interfaceElementSlice.actions.createOne,
}

const FormComponentIE: FC<FormComponentProps> = ({ form }) => {
	const [addElementVisible, setAddElementVisible] = useState<boolean>(false)

	const interfaceElements = useSelector(interfaceElementsSelector.getAll)
	const interfaceElementsKinds = useSelector(dictsSelector.getInterfaceElementsKinds)

	const { createOne } = useAppDispatch(actions)

	const levelMenuCheck = (data): boolean => {
		let result = true
		if (data.parent_element_id) {
			const parentElementId = +data.parent_element_id
			const parent_element = interfaceElements.entries.find(
				(el): boolean => parentElementId === el.id
			)
			if (parent_element && parent_element.parent_element_id) {
				result = false
				message.error('Нельзя создавать меню третьего уровня')
			}
		}
		return result
	}

	const hideDrawer = () => {
		setAddElementVisible(false)
		form.resetFields()
	}

	const showDrawer = () => {
		setAddElementVisible(true)
	}

	useUnmount(() => {
		form.resetFields()
	})

	const handleSubmit = (e: React.FormEvent<EventTarget>): void => {
		e.stopPropagation()
		e.preventDefault()

		form.validateFields((err, values): void => {
			if (!err) {
				const element = Deserialize(values, InterfaceElementModel)
				if (!levelMenuCheck(element)) {
					return
				}
				createOne(element)
				hideDrawer()
			}
		})
	}

	return (
		<Block>
			<BtnComponent onClick={showDrawer} title="Добавить" />
			<DrawerComponent
				title={i18n('nav.add_new_interface_element')}
				width="50%"
				onClose={hideDrawer}
				visible={addElementVisible}
				closable
			>
				<div>
					<FormBlockComponent>
						<InputComponent
							form={form}
							placeholder={i18n('common.name_enter')}
							fieldName={FieldNames.NAME}
							fieldOptions={{
								rules: [
									{
										required: true,
										message: i18n('errors.name_enter_required'),
									},
								],
							}}
						/>
					</FormBlockComponent>

					<FormBlockComponent>
						<InputComponent
							form={form}
							placeholder={i18n('common.icon')}
							fieldName={FieldNames.ICON}
						/>
					</FormBlockComponent>

					<FormBlockComponent>
						<InputComponent
							form={form}
							placeholder={i18n('common.address')}
							fieldName={FieldNames.URL}
						/>
					</FormBlockComponent>

					<FormBlockComponent>
						<InputComponent
							form={form}
							placeholder={i18n('common.order')}
							fieldName={FieldNames.ORDER}
						/>
					</FormBlockComponent>

					<FormBlockComponent>
						<InputComponent
							form={form}
							placeholder={i18n('common.parent_element_id')}
							fieldName={FieldNames.PARTNER_ELEMENT_ID}
						/>
					</FormBlockComponent>
					<FormBlockComponent>
						<SelectComponent
							items={interfaceElementsKinds}
							placeholder="common.no_select"
							form={form}
							fieldName={FieldNames.KIND}
							fieldOptions={{
								rules: [
									{
										required: true,
									},
								],
							}}
						/>
					</FormBlockComponent>
				</div>
				<WrapperButton>
					<BtnComponent onClick={handleSubmit} title="Сохранить" />
				</WrapperButton>
			</DrawerComponent>
		</Block>
	)
}

export const FormIE = Form.create<FormComponentProps>({
	name: FormNames.INTERFACE_ELEMENT,
})(FormComponentIE)
